import { c as _c } from "react/compiler-runtime";
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { Typography } from '@mui/material';
export const BalanceTransferFee = t0 => {
  const $ = _c(3);
  const {
    creditCardOffer
  } = t0;
  const {
    details: t1
  } = creditCardOffer;
  const {
    balanceTransferFee
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontSize: "inherit"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = balanceTransferFee || "N/A";
  let t4;
  if ($[1] !== t3) {
    t4 = <Typography sx={t2}>{t3}</Typography>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
};